<template>
  <div>
    <!-- Hero Section -->
    <section class="pt-32 pb-16">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="text-center">
          <h1 class="text-5xl md:text-6xl font-headings mb-6 text-secondary-900">
            Become a Partner

          </h1>
          <p class="text-xl text-secondary-600 max-w-xl mx-auto">
            We're always looking for new partners to grow with. Let's chat about how we can work together.
          </p>
        </div>
      </div>
    </section>

    <ContentWrapper>
      <div class="text-white flex flex-col md:flex-row items-center justify-center pb-24">
        <div class="w-full md:w-1/2">
          <img :src="becomeAPartnerImage" alt="Become a Partner"
            class="w-full object-cover h-64 md:h-[500px] rounded-br-4xl rounded-tl-4xl">
        </div>
        <div class="w-full md:w-1/2">
          <div ref="hubspotFormRef" id="hubspot-form-container">
            <div class="flex items-center justify-center">
              Loading...
            </div>
          </div>
        </div>
      </div>
    </ContentWrapper>

    <CtaSignup />
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import ContentWrapper from '@/components/Layouts/ContentWrapper.vue'
import CtaSignup from '@/components/Blocks/CtaSignup.vue'
import becomeAPartnerImage from '@/images/photography/full/entegy-3.png'
const hubspotFormRef = ref(null)

function loadHubSpotForm() {
  if (typeof hbspt === 'undefined') {
    const script = document.createElement('script')
    script.src = '//js-ap1.hsforms.net/forms/embed/v2.js'
    script.charset = 'utf-8'
    script.async = true
    script.onload = () => createHubSpotForm()
    document.head.appendChild(script)
  } else {
    createHubSpotForm()
  }
}

function createHubSpotForm() {
  if (hubspotFormRef.value && typeof hbspt !== 'undefined') {
    hbspt.forms.create({
      portalId: '20525915',
      formId: '300ab792-8de7-4b8f-b8a6-d5ce0588e10b',
      region: 'ap1',
      target: '#hubspot-form-container'
    })
  }
}

onMounted(() => {
  loadHubSpotForm()
})
</script>
